import { Site } from '@jucy/rentals-api-client';
import { makeAutoObservable, runInAction } from 'mobx';

export default class TranslationStore {
    currentNamespace = 'nz';

    constructor(initialData?: Partial<TranslationStore>) {
        makeAutoObservable(this);
        Object.assign(this, initialData);
    }

    setNameSpaceForSite = (site?: Site): void => {
        runInAction(() => {
            this.currentNamespace = site?.countryCode || this.currentNamespace;
        });
    };
    hydrate = (data: Partial<TranslationStore>): void => {
        Object.assign(this, data);
    };
}
